/* import __COLOCATED_TEMPLATE__ from './selected-log-container.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class SelectedLogContainer extends Component {
  @tracked openSectionId;
  @service intl;

  @action
  onOpenSectionChange(sectionId) {
    this.openSectionId = sectionId;
  }

  get requestBannerErrorText() {
    return this.intl.t('components.workflow-connector.builder.selected-log.banner-text-help');
  }

  get requestBannerText() {
    return this.requestSuccessful
      ? this.intl.t(
          'components.workflow-connector.builder.selected-log.request-banner-text-success',
        )
      : this.args.selectedAction.errorType;
  }

  get requestBannerType() {
    return this.requestSuccessful ? 'green' : 'red';
  }

  get responseBannerSuccessText() {
    return this.intl.t(
      'components.workflow-connector.builder.selected-log.response-banner-text-success',
      {
        httpStatus: this.args.selectedAction.httpStatus,
      },
    );
  }
  get responseBannerText() {
    if (!this.requestSuccessful) {
      return this.requestBannerErrorText;
    }
    if (!this.responseSuccessful) {
      return this.args.selectedAction.errorType;
    }
    return this.bodyIsEmpty(this.args.selectedAction.responseBody)
      ? this.intl.t(
          'components.workflow-connector.builder.selected-log.fin-usage.response-banner-text-no-data',
        )
      : this.responseBannerSuccessText;
  }

  get responseFullErrorMessage() {
    return this.intl.t(
      'components.workflow-connector.builder.selected-log.response-banner-text-full-error',
      {
        errorMessage: this.errorMessage,
      },
    );
  }

  get responseBannerType() {
    if (!this.requestSuccessful) {
      return 'gray';
    }
    if (!this.responseSuccessful) {
      return 'red';
    }
    return this.bodyIsEmpty(this.args.selectedAction.responseBody) ? 'gray' : 'green';
  }

  get responseMappingBannerText() {
    if (this.requestSuccessful && this.responseSuccessful) {
      return this.responseMappingSuccessful
        ? this.intl.t(
            'components.workflow-connector.builder.selected-log.mapping-banner-text-success',
          )
        : this.args.selectedAction.errorType;
    }
    return this.intl.t('components.workflow-connector.builder.selected-log.banner-text-help');
  }

  get responseMappingBannerType() {
    if (this.requestSuccessful && this.responseSuccessful) {
      return this.responseMappingSuccessful ? 'green' : 'red';
    }
    return 'gray';
  }

  get mappingHelpMessage() {
    return this.intl.t('components.workflow-connector.builder.selected-log.mapping-help-message');
  }

  get requestBody() {
    if (this.args.selectedAction.requestBody) {
      try {
        let json = JSON.parse(this.args.selectedAction.requestBody);
        return JSON.stringify(json, null, 2);
      } catch (error) {
        // If it's not valid JSON, return the raw string
        return this.args.selectedAction.requestBody;
      }
    }
    return null;
  }

  get responseBody() {
    let body = this.args.selectedAction.responseBody;
    if (!this.bodyIsEmpty(body) && this.responseSuccessful) {
      let json = JSON.parse(body);
      return JSON.stringify(json, null, 2);
    }
    return null;
  }

  get rawResponseBody() {
    if (this.args.selectedAction.rawResponseBody) {
      try {
        let json = JSON.parse(this.args.selectedAction.rawResponseBody);
        return JSON.stringify(json, null, 2);
      } catch (error) {
        // If it's not valid JSON, return the raw string
        return this.args.selectedAction.rawResponseBody;
      }
    }
    return null;
  }

  get requestSuccessful() {
    return this.args.selectedAction.httpStatus > 0;
  }

  get responseSuccessful() {
    return this.args.selectedAction.httpStatus >= 200 && this.args.selectedAction.httpStatus < 300;
  }

  get responseMappingSuccessful() {
    return this.args.selectedAction.errorMessage === null;
  }

  get errorMessage() {
    return this.args.selectedAction.errorMessage;
  }

  get httpMethodString() {
    return this.args.selectedAction.httpMethod
      ? this.args.selectedAction.httpMethod.toUpperCase()
      : '';
  }

  get isCustomBot() {
    if (
      this.args.selectedAction.sourceType.includes(
        this.intl.t('components.workflow-connector.builder.selected-log.bot'),
      )
    ) {
      return true;
    }
    return false;
  }

  bodyIsEmpty(body) {
    if (body === null || body === undefined) {
      return true;
    }

    let jsonBody = JSON.parse(body);

    return Array.isArray(jsonBody) ? jsonBody.length === 0 : Object.keys(jsonBody).length === 0;
  }
}
